import { render, staticRenderFns } from "./BestAthletesEventDashboard.vue?vue&type=template&id=03d3ece8&"
import script from "./BestAthletesEventDashboard.vue?vue&type=script&lang=ts&"
export * from "./BestAthletesEventDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./BestAthletesEventDashboard.vue?vue&type=style&index=0&id=03d3ece8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports